module.exports = __webpack_public_path__ + "static/media/logo.45903e1f.svg";